import { menuItems } from '@lib/constants/sidemenu/nass-sidemenu.constants';
import { Theme } from '../theme.interface';
import { SendMoneyComponent } from '@pages/send-money/nass/send-money.component';
import { NassHomeComponent } from '@pages/home/components/nass-home/nass-home.component';

export const nassConfig: Theme = {
    name: 'nassConfig',
    properties: {
        '--font-family': 'Readex Pro',
        '--primary-color': '#4656AD',
        '--primary-color-light': '#4656AD',
        '--border-radius': '6.25rem',
        '--heading-font-size': '3rem',
    },
    assets: {
        clientName: 'NASS',
        otpFieldStyle: 'input-otp-underlined',
        loginSvg: 'assets/nass/login-right-background-cover.mp4',
        logoSvg: 'assets/nass/logo.png',
        sideMenu: menuItems,
        loginFlow: 'passcode',
        homeComponent: NassHomeComponent,
        loginLayoutColumnLeft: 'col-lg-4',
        loginLayoutColumnRight: 'col-lg-8',
        sendMoneyComponent: SendMoneyComponent,
        allowedCountriesInPhoneSearch: ['iq'],
        favicon: 'assets/nass/favicon.ico',
    },
};
